import { render, staticRenderFns } from "./EditUpdateBeneficiariesModal.vue?vue&type=template&id=7e2dbb00"
import script from "./EditUpdateBeneficiariesModal.vue?vue&type=script&lang=js"
export * from "./EditUpdateBeneficiariesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports